<template>
    <div v-on-clickaway="close" class="relative">
        <div @click="toggle">
            <slot name="toggler">
                <button>Toggle</button>
            </slot>
        </div>

        <transition
            enter-active-class="transition ease-out duration-100 transform"
            enter-from-class="opacity-0 scale-95"
            enter-to-class="opacity-100 scale-100"
            leave-active-class="transition ease-in duration-75 transform"
            leave-from-class="opacity-100 scale-100"
            leave-to-class="opacity-0 scale-95"
        >
            <div v-show="open" class="origin-top-right absolute right-0 z-10 w-48 py-1 -mr-1 bg-white divide-y divide-gray-100 rounded shadow-lg" :class="options">
                <slot/>
            </div>
        </transition>
    </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';

export default {
    mixins: [ clickaway ],

    props: {
        top: { required: false },
        width: { required: false },
    },

    data() {
        return {
            open: false,
        }
    },

    created() {
        document.addEventListener('keyup', (e) => {
            if (e.key === 'Escape') {
                this.close();
            }
        });

        this.options = (this.width ? 'w-' + this.width : '') + ' ' + (this.top ? 'mt-' + this.top : '');
    },

    methods: {
        toggle() {
            this.open = !this.open;
        },

        close() {
            this.open = false;
        },
    },
}
</script>
